import { render } from "./IconDuration.vue?vue&type=template&id=499bbe62"
import script from "./IconDuration.vue?vue&type=script&lang=js"
export * from "./IconDuration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__